import Link from "next/link";
import { Star } from "lucide-react";

// Compacte ranglijst voor de homepage: positie, rijder, waarde. Gebruikt voor
// zowel een wedstrijduitslag (afstand) als een klassement (punten).
export type MiniRij = {
  positie: number;
  titel: string;
  ondertitel: string;
  waarde: string;
  href: string | null;
  /** Een team dat de bezoeker volgt; krijgt een ster en een oranje rand. */
  uitgelicht?: boolean;
};

export function MiniTabel({
  rijen,
  waardeKop,
}: {
  rijen: MiniRij[];
  waardeKop: string;
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-[#2a4a6f] bg-card">
      <div className="flex items-center gap-3 border-b border-[#2a4a6f] px-3 py-2 text-[0.65rem] font-bold uppercase tracking-wide text-primary">
        <span className="w-6 shrink-0">Pos</span>
        <span className="min-w-0 flex-1">Rijder</span>
        <span className="shrink-0 text-right">{waardeKop}</span>
      </div>
      <ul>
        {rijen.map((r) => {
          const inhoud = (
            <>
              <span className="w-6 shrink-0 font-display text-sm font-black tabular-nums text-white">
                {r.positie}
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-1.5">
                  {r.uitgelicht && (
                    <Star
                      className="size-3.5 shrink-0 fill-primary text-primary"
                      aria-label="Team dat je volgt"
                    />
                  )}
                  <span className="truncate text-sm font-bold text-white">{r.titel}</span>
                </span>
                {r.ondertitel && (
                  <span className="block truncate text-xs text-muted-foreground">{r.ondertitel}</span>
                )}
              </span>
              <span className="shrink-0 text-right font-mono text-sm tabular-nums text-soft-foreground">
                {r.waarde}
              </span>
            </>
          );
          return (
            <li
              key={`${r.positie}-${r.titel}`}
              className={
                r.uitgelicht
                  ? "border-b border-[#2a4a6f] bg-primary/10 last:border-b-0"
                  : "border-b border-[#2a4a6f] last:border-b-0"
              }
            >
              {r.href ? (
                <Link
                  href={r.href}
                  className="flex items-center gap-3 px-3 py-2.5 transition-colors active:bg-white/5"
                >
                  {inhoud}
                </Link>
              ) : (
                <div className="flex items-center gap-3 px-3 py-2.5">{inhoud}</div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
